<template>
  <div style="position: relative; background-color: #ececec; width: 100vw; height: 100vh;">
    <vue-headful title="Login" description="Aimz"/>
    <v-img  :src="require('@/assets/trees.png')" style="position: absolute; opacity: 0.2;" height="100vh" width="100vw" position="left"></v-img>
    <div style="position: absolute; width: 100vw; height:100vh;" class="d-flex">
      <center-container class="d-flex align-center">
        <div>

        <v-container class="elevation-5 white mt-n3 mt-sm-10 mb-5 rounded-l rounded-r" style="max-width: 500px;">
            <v-row class="pt-5 pb-3 px-3">
              <v-col :cols="12">

                <!--      heading-->
                <center-container>
                  <v-img class="ma-5 mt-10" :src="require('@/assets/aimz.svg')" max-width="300"></v-img>
                </center-container>

                <center-container style="width: 100%;">
                  <div class="d-flex pt-5 pb-3 px-2" style="width: 300px;">
<!--                  <h1 class="display-1 gelb&#45;&#45;text text-center">Login</h1>-->
                  <v-form style="width: 100%;">
                    <v-container class="pa-0" style="width: 100%;">
                      <v-layout column wrap>

                        <v-flex>
                          <v-text-field
                              autocomplete="email"
                              v-model="email"
                              placeholder="Email"
                          ></v-text-field>
                        </v-flex>

                        <v-flex>
                          <v-text-field
                              v-model="pw"
                              autocomplete="current-password"
                              placeholder="Password"
                              type="password"
                              @keydown.enter="login"
                          ></v-text-field>
                        </v-flex>

                        <v-flex text-xs-center class="mt-0">
                          <center-container>
                            <div v-if="error">
                              <v-alert type="error">
                                Fehler: {{ reason }}
                                <v-btn class="ml-1" @click="retry">OK</v-btn>
                              </v-alert>
                            </div>
                            <v-btn v-else color="dunkelblau" class="full_width gelb--text" @click.prevent="login">
                              Login
                              <v-progress-circular v-if="loading" indeterminate class="ma-1"
                                                   size="24"></v-progress-circular>
                            </v-btn>
                          </center-container>
                          <p class="mt-3 text-center">Du hast noch keinen Account? <br><router-link to="/signup" class="dunkelblau--text">Jetzt kostenlos registrieren</router-link></p>
                          <p class="mt-3 text-center"><router-link to="/pw_reset"  class="dunkelblau--text">Passwort vergessen?</router-link></p>
                        </v-flex>

                        <div v-if="account_not_activated">
                          <v-alert type="info" class="mt-5">
                            Aktivierungslink klicken.
                          </v-alert>
                          <p>
                            Damit du dich einloggen kannst, muss der Account aktiviert werden.
                            Dafür solltest du eine Email mit einem Aktivierungslink bekommen haben. Prüfe bitte auch den
                            Spamordner.<br><br>
                            Solltest du das Email nicht finden, kannst du es
                            <router-link to="/verify">noch einmal anfordern.</router-link>
                          </p>
                        </div>

                      </v-layout>
                    </v-container>
                  </v-form>
                </div>
                </center-container>
              </v-col>
            </v-row>
        </v-container>
        <div class="text-center grey--text">
          <router-link class="grey--text body-2" to="/impressum">Impressum</router-link> |
          <router-link class="grey--text body-2" to="/datenschutz">Datenschutz</router-link>
        </div>
        </div>
      </center-container>
    </div>
  </div>
</template>

<script>
//import Logo from '@/components/Logo.vue'

import CenterContainer from "@/components/CenterContainer";

export default {
  components: {
    CenterContainer
    // Logo,
  },
  data() {
    return {
      email: null,
      pw: null,
      loading: false,
      error: false,
      reason: '',
      account_not_activated: false,
      returnTo: "/lobby",
    }
  },
  mounted() {
    //console.debug(this.$app, this.$app.data)
    var self = this;
    console.log("$route:", this.$route);
    var returnTo=this.$route.query.returnTo || "/lobby";
    this.$backend.check_session({
      onSuccess() {
        self.$router.replace(returnTo)
      },
      no_notify:true,
    });
    if (this.$route.params.email)
      this.email = this.$route.params.email;
  },
  methods: {
    async login() {
      this.loading = true;
      this.account_not_activated = false;
      this.error = false;
      this.reason = '';
      var data=await this.$backend.login(this.email, this.pw, { onError: this.onError});
      this.loading = false;
      if (!data) {
        return;
      }
      //  { email:email, token: data.token, user:data.user }
      this.$app.onLogin(data.token, data.user);
      this.error = false;
      this.$router.go(-1000);
      this.$router.replace(this.returnTo);
    },
    onError(msg, data) {
      this.loading = false;
      if (!data)
        this.reason="Server antwortet nicht"
      else
        this.reason = data.reason||"Server antwortet nicht";
      if (data && data.code == 3) // account not activated
      {
        this.account_not_activated = true;
      }
      this.$events.$emit("error", this.reason)
      console.error("Login failed. reason: " + data.reason + "\n" + data.error)
    },
    retry() {
      this.error = false;
      this.reason = '';
      this.loading = false;
    },
    // async login() {
    //     this.loading=true;
    //     //var data={};
    //     this.$backend.login()
    //     try {
    //         const response = await this.$axios.get('/api/login', {params: {email: this.email, password: this.pw}});
    //         if (response.status==200)
    //             data=response.data;
    //         else
    //             data.reason=response.statusText;
    //     }
    //     catch (e) {
    //         // handle error
    //         console.error(e);
    //         this.$events.$emit("snack", {msg:e.message, autoclose:false});
    //         this.pw=null;
    //         return;
    //     }
    //     finally {
    //         this.loading=false;
    //     }
    //     console.log({data});
    //     if (!data || !data.success) {
    //         this.$events.$emit("snack", {msg:data ? data.reason : "login returned null?", autoclose:true});
    //         return;
    //     }
    //     else {
    //         this.$store.commit("login", data);
    //         var goto=this.$store.state.goto;
    //         if (goto) {
    //             this.$store.commit("set", {key:"goto", value: null});
    //             this.$router.replace(goto);
    //         }
    //         else
    //             this.$router.replace("/home");
    //     }
    // },
  },
  computed: {
    mobile() { return this.$vuetify.breakpoint.smAndDown; },
    desktop(){ return this.$vuetify.breakpoint.mdAndUp; }
  }
}
</script>
